var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.tutorialChat && _vm.chatStart)?_c('AbstractChat',{attrs:{"X1":"Hamochie","chats":_vm.tutorialChat,"callback":_vm.callback}}):_vm._e(),_c('SkipTut'),(_vm.apiError && _vm.apiError.isError)?_c('ApiErrorDialog',{attrs:{"api":_vm.apiError}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }